import React from "react";
import OnboardingWrapper from "../components/OnboardingWrapper";
import OnboardingProgressBar from "./OnboardingProgressBar";
import useWindowWidth from "../hooks/useWindowWidth";
import PlansGrid from "../components/PlansGrid";
import useCompanyUsage from "../hooks/useCompanyUsage";
import { useCompanyApi } from "../hooks/useCompanyApi";

const SubscriptionPage = () => {
  useCompanyUsage();
  const { updateCompany } = useCompanyApi();
  const width = useWindowWidth();

  return (
    <OnboardingWrapper
      actions={
        width > 640 ? (
          <div className="pb-20 justify-center w-full flex">
            <OnboardingProgressBar currentStep={4} />
          </div>
        ) : undefined
      }
    >
      <div className="mb-6">
        <div className="px-4 mt-20">
          <h1 className="text-xl mb-5 font-semibold text-center text-primary">
            Pricing
          </h1>

          <h2 className="text-3xl mb-5 font-semibold text-center">
            Simple, transparent pricing
          </h2>

          <p className="text-lg mb-5 text-center text-gray-600 max-w-3xl m-auto">
            We believe AI Customer Support Agents with full end to end
            automation should be accessible to all companies, no matter the
            size.
          </p>
        </div>

        <PlansGrid
          successUrl={window.location.origin + `/dashboard/home`}
          onCompleted={async () => {
            await updateCompany({
              registration_step: "completed",
            });
          }}
        />
      </div>
    </OnboardingWrapper>
  );
};

export default SubscriptionPage;
